<template>
  <v-dialog 
    v-model="dialog" 
    fullscreen 
    persistent 
    hide-overlay 
    transition="dialog-bottom-transition"
  >
    <dialogconfirmaddstake 
      ref="confirmAddstake" 
      @load="closeAndClear"
    />
    <v-card 
      class="toolbartab" 
      style="position : fixed; height:100%"
    > 
      <v-row 
        no-gutters 
        class="mx-2 pt-2 white--text"
      >
        <h3>{{ $t('bet-item') }}</h3>
        <v-spacer /> 
        <v-btn 
          icon 
          dark 
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-divider /> 

      <v-row
        v-if="voucher.uuid"
        no-gutters
      >
        <v-col
          cols="12"
        >
          <v-list-item-title  
            class="px-3 white--text"
          >
            {{ $t('voucher-used') }} :
          </v-list-item-title>
          <v-list
            color="pink"
            dark
          >
            <v-list-item>
              <v-list-item-avatar>
                <v-img 
                  :src="voucher.image_url"
                /> 
              </v-list-item-avatar> 
              <v-list-item-content>
                <v-list-item-title>
                  {{ voucher.name }}
                </v-list-item-title>
                <v-list-item-subtitle v-if="voucher.rules.stake_quota_limit">
                  {{ $t('max-stake') }} {{ voucher.rules.stake_quota_limit }} {{ $t('unit.credit') }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="voucher.rules.stake_max_number">
                  {{ $t('max-number') }} {{ voucher.rules.stake_max_number }} {{ $t('unit.amount') }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                {{ `x${voucher.amount}` }} 
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <v-row 
        no-gutters 
        class="mx-2"
      > 
        <v-col 
          class="my-2" 
          cols="12"
        >
          <h5 class="white--text">
            {{ $t('stake-same-price') }}
          </h5>
          <n-number-field-specific
            v-model="allPrice"
            :placeholder="$t('placeholder.each-number')"
            hide-details="auto" 
            solo   
          />
        </v-col>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col 
              class="mr-1"
            >
              <v-btn
                depressed
                dark
                color="pink"
                small 
                width="100%"
                @click="clearAllCheck"
              >
                ล้างเลขทั้งหมด
              </v-btn> 
            </v-col>
            <v-col
              class="ml-1"
            >
              <v-btn
                dark 
                color="orange"
                depressed
                small 
                width="100%"
                @click="removeSameNumber"
              >
                ตัดเลขซ้ำ
              </v-btn>
            </v-col>
          </v-row>
        </v-col> 
      </v-row>
      <v-row 
        no-gutters 
        class="ma-2"
      > 
        <Group
          @addItemFromDialog="addItemFromDialog"  
        /> 
        <v-spacer />
        <div class="white--text text-end">
          <h6>รายการทั้งหมด</h6>
          <h6>{{ userSelect.length }}</h6>
        </div>
      </v-row>
      <v-divider />   
      <div style="height:calc(100% - 200px)">
        <resultlist   
          :number-conditions="numberConditions"
          :user-select="userSelect"
          :sum-user-price="sumUserPrice"
          :open-delete-row="delValue"
        />  
      </div>
      <v-footer 
        padless
        fixed
      >
        <v-row
          no-gutters
          align="center"
        > 
          <v-col
            v-if="isNotRoleUser"
            cols="12"
          >
            <n-text-field-noemoji
              v-model="description"  
              :placeholder="$t('placeholder.description')" 
              hide-details
            /> 
          </v-col>
          <v-col class="text-center mt-3">
            <h6>{{ $t('remaining-credit') }} </h6>
            <b>{{ creditAmount | currency }}</b>
          </v-col> 
          <v-col class="text-center mt-3">
            <h6>{{ $t('sum-stake-amount') }}</h6>
            <b>{{ total | currency }}</b> 
          </v-col> 
          <v-col class="ma-2">
            <h5 class="red--text">
              {{ errorMessage }}
            </h5>
            <v-btn  
              block
              x-large 
              depressed
              class="white--text"
              :loading="submitStatus"
              :disabled="submitStatus"
              color="var(--bg-secondary-color)"
              @click="addStake"
            >
              {{ $t('button.stake-bet') }} 
            </v-btn> 
          </v-col>  
        </v-row>
      </v-footer>
    </v-card>
  </v-dialog>
</template>
<script>   
import { gameRooms as apiGameRooms } from '@/apis' 
import { SPECIAL_ROLE_GROUP } from '@/const/roleId'
import Group from '@/components/Dialog/DialogGropnumberPullpoll'
import dialogconfirmaddstake from '../../childs/ConfirmAddStake'
import resultlist from '../../childs/ResultList'

export default {
  components : {
    Group,
    resultlist, 
    dialogconfirmaddstake
  },

  props : {
    numberConditions:{
      type:Array,
      default:()=>{
        return[]
      }
    },
    userSelect:{
      type:Array,
      default:()=>{
        return[]
      }
    }, 
    voucher:{
      type:Object,
      default:()=>{}
    }  
  },

  data () {
    return  {
      dialog : false,
      allPrice :'', 
      total : 0,
      description:null,
      submitStatus:false, 
      errorMessage:null, 
    }
  }, 

  computed : { 
    creditAmount () {
      return (this.wallet || {}).amount || 0
    },
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    routeId () {
      return this.$route.query.id
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    userRoleId () {
      return ((this.userProfile || {}).role || {}).id
    },
    isNotRoleUser () {
      return SPECIAL_ROLE_GROUP.includes(this.userRoleId)
    }
  },

  watch:{
    userSelect () { 
      this.errorMessage=''
      this.sumUserPrice()
    },
    allPrice () {
      if(this.allPrice!==null){ 
        if(parseInt(this.allPrice)<0){  
          this.allPrice = null
        }
        this.allPriceList ()
      } 
    } 
  },
  methods : { 

    addItemFromDialog (item){
      this.$emit('addItemFromDialog',item)
    }, 

    open () {
      this.errorMessage=''
      this.dialog = true
    },

    close () {
      this.dialog = false
    },

    closeAndClear () {
      this.dialog = false 
      this.allPrice = ''
      this.errorMessage = ''
      this.total = 0 
      this.$emit('load')
    },

    switchNumberToggle () {
      this.$emit('switchNumberToggle')
    },

    delValue (number){  
      this.$ga.event('Button', 'DeleteStakeMobile', 'ResultSelectBet', number) 
      this.$confirm('',this.$t('confirm.cancel-this-number'),'warning').then(()=>{ 
        this.errorMessage = ''
        this.$emit('delValue',number) 
      }).catch(()=>{}); 
    }, 

    async addStake () { 
      var entireStake = []
      var breakStatus = false
      this.submitStatus = true
      this.$ga.event('Submit', 'AddStakeWeb', 'ResultSelectBet', '') 
      let stakeQuotaLimit = (this.voucher.rules || {}).stake_quota_limit
      let checkVoucherStakeTotal = this.voucher.rules && stakeQuotaLimit

      this.numberConditions.forEach(cond => {
        const items = this.userSelect.filter(x=> x.number_type_id === cond.number_type.id)
        const lengthPerCondition = (items || []).length
        //check max number list per number condition
        if(cond.max_unit_per_number_per_list && cond.max_unit_per_number_per_list < lengthPerCondition) { 
          breakStatus = true
          this.errorMessage=`${cond.number_type.name} ${this.$t('validate.maximun-stake-is')} ${cond.max_unit_per_number_per_list} ${this.$t('unit.unit-per-number-per-list')}`
          return
        }

        //check max number user per number condition
        if(cond.max_number_per_user && cond.max_number_per_user < lengthPerCondition) { 
          breakStatus = true
          this.errorMessage=`${cond.number_type.name} ${this.$t('validate.maximun-stake-is')} ${cond.max_number_per_user} ${this.$t('unit.number-per-user')}`
          return
        }
        
        items.forEach(element=>{ 
          //check empty field
          if(!breakStatus && (element.unit === null || element.unit==='')) { 
            breakStatus = true
            this.errorMessage=`${this.$t('validate.please-enter-number-numbers')} ${element.number}`
            return
          }   

          // totalPerCondition += parseInt(element.unit || 0)
          entireStake.push({
            number:element.number,
            number_type_id:element.number_type_id,
            unit:element.unit
          }) 
        }) 
      })
      
      await Promise.all(entireStake)

      if(breakStatus) { 
        this.submitStatus = false 
        return
      }  
      
      if(checkVoucherStakeTotal && this.total > parseInt(stakeQuotaLimit)) {
        this.errorMessage=` ${this.$t('number-condition.maximum-bet')} ${stakeQuotaLimit} ${this.$t('unit.credit')}`
        this.submitStatus = false 
        return
      }

      if (entireStake.length===0) {
        this.errorMessage= this.$t('validate.please-choose-bet-number')
        this.submitStatus = false 
      } else if (this.creditAmount - this.total<0){ 
        this.errorMessage=this.$t('validate.money-not-enough')
        this.submitStatus = false 
      } else {
        this.apiaddStake(this.routeId,entireStake) 
      }  
    }, 

    async apiaddStake (id,stakes) {
      let params = {
        stakes:stakes
      }

      if(this.voucher.uuid) {
        params.voucher_uuid = this.voucher.uuid
      }

      if(this.description){
        params.description = this.description
      }
      
      const [err,data] = await apiGameRooms.postAddStake(id,params)

      this.submitStatus = false
      
      if(err){
        this.$alert('',err,'warning') 
        return
      }

      if(data) {
        this.$refs.confirmAddstake.openDialog(data,this.numberConditions)   
      } 
    }, 
    
    removeSameNumber () {  
      this.$ga.event('Button', 'RemoveSameNumberMobile', 'ResultSelectBet', '')
      this.errorMessage = ''
      this.$emit('removeSameNumber')
    },
    
    findElement (id){
      return this.numberConditions.find(x=>x.number_type.id===id)
    },

    allPriceList () {
      this.errorMessage=''
      this.total = 0
      if(this.userSelect.length>0){
        this.userSelect.forEach(element => {
          let condition = this.findElement(element.number_type_id) 
          element.unit = condition.max_unit_per_number_per_list > this.allPrice ? this.allPrice : condition.max_unit_per_number_per_list
          if(element.unit!==null){
            this.total += element.unit*condition.price
          }
        }); 
      } 
    },

    sumUserPrice () {
      this.total = 0
      if(this.userSelect.length>0){
        this.userSelect.forEach(element => { 
            if(element.unit!==null){
              this.total += element.unit*this.findElement(element.number_type_id).price
            }
        }); 
      } 
    }, 

    clearAllCheck () { 
      this.$confirm('',this.$t('confirm.remove-all-stake-list'),'warning').then(()=>{ 
        this.clearAll ()
      }).catch(()=>{}); 
    },

    clearAll () { 
      this.$ga.event('Button', 'ClearAllMobile', 'ResultSelectBet', '')
      this.allPrice = ''
      this.errorMessage = ''
      this.total = 0 
      this.$emit('clearAll')
    },  
  }
}
</script>